const path = '/test';

async function fetchContentResources(contentId) {
  const data = new FormData();
  data.set('contentid', contentId);
  
  const resources = await fetch(`https://api.ementoringafrica.or.ke${path}/ema?action=content_resources_list`, {
    method: 'POST',
    body: data,
  });

  return resources.json();
}

function renderContentResources(hookElement, resources) {
  if (!hookElement) return;

  const template = document.querySelector('[data-resource-tpl]');

  resources.forEach((resource) => {
    const resourceHtml = template.cloneNode(true);
    
    resourceHtml.id = resource.id;

    const resourceType = resource.resource_type || resource.path.split('.').pop();
    resourceHtml.querySelector('[data-resource-name]').textContent = `${resource.name} (${resourceType})`;
    resourceHtml.querySelector('[data-resource-description]').innerHTML = resource.description;
    resourceHtml.querySelector('a').href = 'https://api.ementoringafrica.or.ke' + path + '/' + resource.path;

    hookElement.appendChild(resourceHtml);
  });
}

document.addEventListener('DOMContentLoaded', async () => {
  const contentResourcesHookElements = document.querySelectorAll('[data-program-content-area] [data-content-resources]');

  const contentIds = Array.from(contentResourcesHookElements).map((hookElement) => hookElement.getAttribute('data-content-resources'));

  try {
    const resources = await Promise.all(
      contentIds.map(async (contentId) => {
        const response = await fetchContentResources(contentId);
        return [contentId, response];
      })
    );
  
    resources.forEach(([contentId, resources]) => {
      if (resources.error) return;
      renderContentResources(
        document.querySelector(`[data-program-content-area] [data-content-resources="${contentId}"]`),
        resources.content_resources_list,
      );
    });
  } catch (error) {
    console.error('Error in fetching or rendering content resources');
    console.error(error);
  }
});